import common from './CommonServer'
import index from './Index'
import order from './Order'
import home from './Home'
import mycenter from './MyCenter'
import Station from './Station'
import storepage from './StorePage'
import productinfo from './PrductInfo'

export default {
    common,
    index,
    order,
    home,
    mycenter,
    storepage,
    productinfo,
    Station,
}



// WEBPACK FOOTER //
// ./src/services/Entrance.js